/**
 * Brand resolver. Reads NEXT_PUBLIC_BRAND at build time (Next inlines
 * NEXT_PUBLIC_* into both server and client bundles) so the same helper
 * works in any rendering context. Defaults to "mightos" so a deployment
 * missing the env still boots cleanly.
 *
 * The brand is the marketing wordmark shown in the header / login screen.
 * Workspace-level body copy ("invite to {workspace}", "your {workspace}
 * account") uses NEXT_PUBLIC_WORKSPACE_NAME instead — the brand applies
 * to the product, the workspace name applies to the customer's tenant.
 */
export type BrandKey = 'mightos' | 'cadrial';

export function brandKey(): BrandKey {
    const v = process.env.NEXT_PUBLIC_BRAND?.toLowerCase();
    if (v === 'cadrial') return 'cadrial';
    return 'mightos';
}

export function brandName(): string {
    const k = brandKey();
    return k === 'cadrial' ? 'Cadrial' : 'Mightos';
}

/**
 * Public path prefix for the brand's app icons (favicon, apple-touch-icon,
 * PWA manifest icons), under public/brand/<key>/.
 */
export function brandIconDir(): string {
    return `/brand/${brandKey()}`;
}

/**
 * Customer-facing tenant name. Used for body copy that addresses the
 * customer's workspace ("invite to {workspace}", "your {workspace}
 * account") — distinct from the product brand.
 */
export function workspaceName(): string {
    return process.env.NEXT_PUBLIC_WORKSPACE_NAME?.trim() || 'the workspace';
}
